exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".uploadedimage-message-thumbnail img{max-width:300px;max-height:300px}.file-message-btn{padding:10px!important;border-radius:30px!important;height:40px!important;width:40px!important}.file-message-filename{margin-left:15px}.file-message-progress{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/sass-loader/dist/cjs.js!./components/chat/fileUpload/fileUploadMessages.scss
// module id = 1160
// module chunks = 0 1